import React from "react";
import { FAQS } from "../mock";
import { Reveal } from "../hooks/useReveal";
import {
  Accordion, AccordionContent, AccordionItem, AccordionTrigger,
} from "./ui/accordion";

export default function Faq() {
  return (
    <section id="faq" className="relative py-24 bg-[#0a0e0c] border-y border-white/5">
      <div className="mx-auto max-w-3xl px-4 sm:px-6 lg:px-8">
        <Reveal className="text-center">
          <span className="text-xs font-bold uppercase tracking-[0.25em] text-[#2fd645]">FAQ</span>
          <h2 className="mt-3 font-display font-extrabold text-white text-4xl sm:text-5xl">
            Questions, answered
          </h2>
        </Reveal>

        <Reveal delay={80} className="mt-12">
          <Accordion type="single" collapsible className="space-y-4">
            {FAQS.map((f, i) => (
              <AccordionItem
                key={f.q}
                value={`item-${i}`}
                className="rounded-2xl border border-white/10 bg-[#0e1311] px-6 data-[state=open]:border-[#2fd645]/40"
              >
                <AccordionTrigger className="text-left text-white hover:no-underline hover:text-[#2fd645] py-5 text-base font-semibold">
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="text-white/60 leading-relaxed pb-5">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </div>
    </section>
  );
}
